import { TrendingUp, TrendingDown, Minus } from "lucide-react";

// Direction: "up_good" => higher is better; "down_good" => lower is better
export default function KpiCard({ label, value, unit, prev, direction = "up_good", icon: Icon, iconColor = "#3b82f6", iconBg = "#dbeafe", prevLabel, testId }) {
  let delta = null;
  let improved = null;
  if (prev != null && prev !== 0 && value != null) {
    delta = ((value - prev) / prev) * 100;
    if (direction === "up_good") improved = delta >= 0;
    else improved = delta <= 0;
  }
  const arrowIcon = delta == null ? Minus : delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  const ArrowIcon = arrowIcon;
  const color = delta == null ? "text-slate-400" : improved ? "text-[#22c55e]" : "text-[#ef4444]";

  return (
    <div
      data-testid={testId}
      className="bg-white p-5 rounded-xl border border-slate-200/60 kpi-shadow relative overflow-hidden hover:-translate-y-0.5 transition-transform"
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-widest text-slate-500">{label}</div>
        </div>
        {Icon && (
          <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: iconBg, color: iconColor }}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
      <div className="text-3xl font-black tracking-tight text-slate-900" data-testid={`${testId}-value`}>
        {value == null ? "—" : typeof value === "number" ? value.toLocaleString(undefined, { maximumFractionDigits: 2 }) : value}
        {unit && <span className="text-lg ml-1 text-slate-400">{unit}</span>}
      </div>
      <div className={`mt-2 flex items-center gap-1 text-xs font-semibold ${color}`}>
        <ArrowIcon className="w-3.5 h-3.5" />
        {delta == null ? (
          <span className="text-slate-400">No comparison</span>
        ) : (
          <span>
            {delta > 0 ? "↑" : delta < 0 ? "↓" : ""} {Math.abs(delta).toFixed(1)}%
            <span className="text-slate-400 font-normal ml-1">vs {prevLabel || "prev"}{prev != null ? ` (${typeof prev === "number" ? prev.toLocaleString(undefined,{maximumFractionDigits:2}) : prev})` : ""}</span>
          </span>
        )}
      </div>
    </div>
  );
}
